import React from "react";
import { Tooltip, Typography, Box } from "@mui/material";

const CenterAlignSx = { display: "flex", alignItems: "center" };

const TruncatedSx = {
  whiteSpace: "nowrap",
  overflow: "hidden",
  textOverflow: "ellipsis",
};

const CustomLabel = ({
  label,
  value,
  variant = "caption",
  tooltip = false,
  element = false,
  sx = {},
}) => {
  return (
    <Box component="div" sx={{ ...CenterAlignSx, ...sx }}>
      {element ? element : <></>}
      <Tooltip title={tooltip ? `${label}: ${value}` : ""} arrow>
        <Typography variant={variant} lineHeight="unset" sx={TruncatedSx}>
          <Box component="span" sx={{ fontWeight: 500 }}>
            {label}:{" "}
          </Box>
          {value}
        </Typography>
      </Tooltip>
    </Box>
  );
};
export default CustomLabel;
